var render = function render(){var _vm=this,_c=_vm._self._c;return _c('geko-base-crud',{attrs:{"config":_vm.config},scopedSlots:_vm._u([{key:"list-indicator",fn:function({ item }){return undefined}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }